export const MY_TRIPS = 'MY_TRIPS';
export const ALL_TRIPS = 'ALL_TRIPS';
